import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  NgModule,
  Output,
  ViewChild,
} from '@angular/core';
import { BemBlock } from '@wipo/w-angular/shared';

import { CommonModule } from '@angular/common';
import { W_LAZY_LOADABLE, WHideEmptyModule, WLazyLoadable, WLazyLoadDirectiveModule } from '@wipo/w-angular/directives';
import { takeUntil } from 'rxjs';
@Component({
    selector: 'w-section',
    templateUrl: './w-section.component.html',
    host: {
        // do not do any special operation for filter buttons
        '[class]': 'autoGroup ? blockClassName("section-auto-group") : blockClassName("section-group")'
    },
    providers: [
        { provide: W_LAZY_LOADABLE, useExisting: forwardRef(() => WSectionComponent) },
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
/*
@id w-section
@name w-section
@status release
@description
*/
export class WSectionComponent extends BemBlock implements AfterViewInit, WLazyLoadable {
  @ViewChild('slotContainer') slotContainer!: ElementRef<HTMLElement>;

  isVisible: boolean = false; // from WLazyLoadable
  isLazyLoading: boolean = false; /* this will be set from lazy loading directive (if present) */
  visibilityChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  // tslint:disable-next-line: max-line-length
  @Input() autoGroup: boolean = false; // no gap between sections with autoGroup=true in edit panel, margin before first and after last section
  isEdit: boolean = false;
  // slotCount = 1;

  constructor(private cd: ChangeDetectorRef, private el: ElementRef) { super(); }

  ngAfterViewInit(): void {
    if (this.isLazyLoading) {
      this.visibilityChange.pipe(
        takeUntil(this.destruction)
      ).subscribe(isVisible => {
        this.isVisible = isVisible;
        this.cd.detectChanges(); // we need to build the template before proceeding
        this.init();
      });
    } else {
      this.isVisible = true; // no lazy loading, always visible
      this.cd.detectChanges();
      this.init();
    }
  }
  private init() {
    setTimeout(() => {
      this.isEdit = isEdit(this.el.nativeElement);
      this.cd.markForCheck();
    });
    // this.runOnMutation(this.slotContainer.nativeElement, { childList: true }, this.countSlotsUsed.bind(this), ['childList']);
    // this.countSlotsUsed();
  }
  // countSlotsUsed() {
  //   const children = Array.from(this.slotContainer.nativeElement.children);
  //   const slot = 'w-slot,f-facet[name=slot],[facet-slot]';
  //   // msMatchesSelector - IE11 compatible
  //   this.slotCount = children.filter(e => e.matches ? e.matches(slot) : (e as any).msMatchesSelector(slot)).length;
  //   this.cd.detectChanges();
  // }
  get blockPrefix() {
    return `b-${this.isEdit ? 'edit' : 'view'}-panel`;
  }
  // get classSection(): string {
  //   return `${this.blockClassName('section')} b-view-panel__section--slots_${this.slotCount}`;
  // }
}
@NgModule({
  imports: [CommonModule, WHideEmptyModule, WLazyLoadDirectiveModule],
  exports: [WSectionComponent],
  declarations: [WSectionComponent]
})
export class WSectionModule { }

// hack to identify parent
const isEdit = (el: HTMLElement): boolean => {
  const parent = el.parentElement;
  if (!parent || parent === el) {
    return false; // section not embedded in panel
  } else
    if (parent.tagName.toLowerCase() === 'w-edit-panel') {
      return true;
    } else if (parent.tagName.toLowerCase() === 'w-view-panel') {
      return false;
    } else {
      return isEdit(parent);
    }
};
